import { httpClient } from '../config';
import { getSelectedIndustryId } from './industryUtils';

export const generateConvReportOptions = (reports) => {
  return reports.map((report) => (
    <option key={report.id} value={report.id}>
      {report.report_name}
    </option>
  ));
};

export const fetchConversionReports = async () => {
  try {
    const industryId = getSelectedIndustryId();
    const response = await httpClient(`/analytics/download_report?industry_id=${industryId}`);
    const data = JSON.parse(response.body);
    return {
      googleConvReports: data.googleConvReports,
      bingConvReports: data.bingConvReports,
      metaConvReports: data.metaConvReports,
    };
  } catch (err) {
    console.error(err);
    return { googleConvReports: [], bingConvReports: [], metaConvReports: [] };
  }
};
